import { Model, modelRegistry } from './Model';
export class Grid extends Model {
    static entity = 'grids';
    id = null;
    categories_column_count = 0;
    categories_row_count = 0;
    products_column_count = 0;
    products_row_count = 0;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            categories_column_count: this.attr(0),
            categories_row_count: this.attr(0),
            products_column_count: this.attr(0),
            products_row_count: this.attr(0),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
}
export default Grid;
modelRegistry.register('Grid', Grid);
//# sourceMappingURL=Grid.js.map